// TypicalTodo (ShipLatch demo, fictional). Nothing secret here; the public source map is the finding.
const state = { todos: [], filter: "all" };
export function addTodo(text) { state.todos.push({ id: state.todos.length + 1, text, done: false }); render(); }
export function toggle(id) { const t = state.todos.find(x => x.id === id); if (t) t.done = !t.done; render(); }
function visible() { return state.filter === "all" ? state.todos : state.todos.filter(t => (state.filter === "done") === t.done); }
function render() { const el = document.getElementById("list"); if (el) el.textContent = visible().map(t => (t.done ? "[x] " : "[ ] ") + t.text).join("
"); }
render();
